exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mail2services{color:#eee;background-color:#2d3169;border-radius:3px}.leftpart{width:70%}.block{margin:1rem 0;padding:1rem 2rem}#mainsection li{margin:9px;line-height:1.3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32c2d82e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/ContactHR.vue
// module id = 663
// module chunks = 0